import { render, staticRenderFns } from "./DocsNew.vue?vue&type=template&id=9e1e34ba"
import script from "./DocsNew.vue?vue&type=script&lang=js"
export * from "./DocsNew.vue?vue&type=script&lang=js"
import style0 from "./DocsNew.vue?vue&type=style&index=0&id=9e1e34ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports